import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  Text,
  Icon,
  HStack,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp, FiSearch, FiX } from "react-icons/fi";

const ModalSelectMonthOld = observer(() => {
  const { pageStore } = useStores();
  const [monthOpen, setMonthOpen] = useState(false);
  const [yearOpen, setYearOpen] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);

  useEffect(() => {
    pageStore.updateSelectedPeriodMonth("");
    pageStore.updateSelectedPeriodYear("");
  }, []);

  const filteredMonths = (pageStore.all_periods?.mouths || [])
    .filter(
      (item) =>
        item?.UF_CRM_1490281786 !== "" &&
        item?.UF_CRM_1490281786 !== "Сделка не закрыта"
    )
    .sort((a, b) => a.UF_CRM_1490281786.localeCompare(b.UF_CRM_1490281786));

  const filteredYears = (pageStore.all_periods?.years || [])
    .filter(
      (item) =>
        item?.UF_CRM_1490282792 !== "" &&
        item?.UF_CRM_1490282792 !== "Сделка не закрыта"
    )
    .sort((a, b) => -(b.UF_CRM_1490282792.localeCompare(a.UF_CRM_1490282792)));

  const handleSelectMonth = (monthValue) => {
    setSelectedMonths((prev) => {
      const updated = prev.includes(monthValue)
        ? prev.filter((val) => val !== monthValue)
        : [...prev, monthValue];

      pageStore.updateSelectedPeriodMonth(updated);
      return updated;
    });
  };

  const handleSelectYear = (yearValue) => {
    setSelectedYears((prev) => {
      const updated = prev.includes(yearValue)
        ? prev.filter((val) => val !== yearValue)
        : [...prev, yearValue];

      pageStore.updateSelectedPeriodYear(updated);
      return updated;
    });
  };

  const handleSelectAllMonths = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // 1–12
    const selectedYears = pageStore.selected_period_years || [];

    let monthsToSelect = [];

    filteredMonths.forEach((item) => {
      const monthNumber = parseInt(item?.UF_CRM_1490281786?.split("_")[0], 10);

      if (selectedYears.includes(currentYear.toString()) || selectedYears.length === 0) {
        monthsToSelect.push(item);
      } else {
        monthsToSelect.push(item);
      }
    });

    const updated =
      selectedMonths.length === monthsToSelect.length
        ? []
        : monthsToSelect.map((item) => item?.UF_CRM_1490281786);

    setSelectedMonths(updated);
    pageStore.updateSelectedPeriodMonth(updated);
  };
  const handleSelectAllYears = () => {
    console.log(pageStore.selected_period_years);
    if (!(pageStore.selected_period_years.length == filteredYears.length)) {
      setSelectedYears([]);
    }
    filteredYears.forEach((item) => {
      handleSelectYear(item.UF_CRM_1490282792);
    })
  };

  const handleSaveMonths = () => {
    pageStore.updateSelectedPeriodMonth(selectedMonths);
    setMonthOpen(false);
  };

  const handleSaveYears = () => {
    pageStore.updateSelectedPeriodYear(selectedYears);
    setYearOpen(false);
  };

  const handleResetMonths = () => {
    setSelectedMonths([]);
    pageStore.updateSelectedPeriodMonth([]);
  };

  const handleResetYears = () => {
    setSelectedYears([]);
    pageStore.updateSelectedPeriodYear([]);
  };

  const toggleMonthDropdown = () => {
    setMonthOpen(!monthOpen);
    if (yearOpen) setYearOpen(false);
  };

  const toggleYearDropdown = () => {
    setYearOpen(!yearOpen);
    if (monthOpen) setMonthOpen(false);
  };

  return (
    <HStack alignItems={"start"}>
      {/* Месяцы */}
      <Box position="relative" width="150px">
        <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
          Выберите месяцы:
        </Text>
        <List spacing={1}>


          {filteredMonths
            .map((item, index) => (
              <ListItem
                key={index}
                borderRadius="md"
                _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
              >
                <Checkbox
                  isChecked={pageStore.selected_period_month.includes(
                    item.UF_CRM_1490281786
                  )}
                  onChange={() => {
                    handleSelectMonth(item.UF_CRM_1490281786);
                  }
                  }
                  colorScheme="blue"
                  color="myColor.white"
                >
                  {item.UF_CRM_1490281786.split("_")[1]}
                </Checkbox>
              </ListItem>
            ))}
          <ListItem
            borderRadius="md"
            _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
          >
            <Checkbox
              isChecked={
                pageStore.selected_period_month.length > 0 &&
                pageStore.selected_period_month.length === filteredMonths.length
              }
              isIndeterminate={
                pageStore.selected_period_month.length > 0 &&
                pageStore.selected_period_month.length < filteredMonths.length
              }
              onChange={handleSelectAllMonths}
              colorScheme="blue"
              color="myColor.white"
            >
              <Text as="span" fontWeight="bold">
                Выбрать все
              </Text>
            </Checkbox>
          </ListItem>
        </List>
      </Box>

      {/* Годы */}
      <Box position="relative" width="150px">
        <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
          Выберите год:
        </Text>
        <List spacing={1}>
          {filteredYears
            .map((item, index) => (
              <ListItem
                key={index}
                borderRadius="md"
                _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
              >
                <Checkbox
                  isChecked={pageStore.selected_period_years.includes(
                    item.UF_CRM_1490282792
                  )}
                  onChange={() => {
                    handleSelectYear(item.UF_CRM_1490282792);
                  }

                  }
                  colorScheme="blue"
                  color="myColor.white"
                >
                  {item.UF_CRM_1490282792}
                </Checkbox>
              </ListItem>
            ))}
          <ListItem
            p={1}
            borderRadius="md"
            _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
          >
            <Checkbox
              isChecked={
                pageStore.selected_period_years.length > 0 &&
                pageStore.selected_period_years.length === filteredYears.length
              }
              isIndeterminate={
                pageStore.selected_period_years.length > 0 &&
                pageStore.selected_period_years.length < filteredYears.length
              }
              onChange={() => { handleSelectAllYears(); handleSaveYears() }}
              colorScheme="blue"
              color="myColor.white"
            >
              <Text as="span" fontWeight="bold">
                Выбрать все
              </Text>
            </Checkbox>
          </ListItem>
        </List>
      </Box>
    </HStack>
  );
});

export default ModalSelectMonthOld;
